var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"my-avatar-root-container"},[(!_vm.img_url)?_c('Avatar',{style:({ background: _vm.color }),attrs:{"size":_vm.size}},[_vm._v(_vm._s(_vm.name[0]))]):_c('Avatar',{attrs:{"size":_vm.size,"src":_vm.img_url}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }